<template>
  <div
    ref='root'
    v-show='visible'
    class='popup confirm'
  >
    <div class='content'>
      <ul class="text">
        <li class="item">
          <p>{{ $t('板は1枚毎に金額が計算されます。') }}</p>
        </li>
        <li class="item">
          <p>{{ $t('部材の内側の切り抜き部分に部材を配置することはできません。') }}</p>
        </li>
        <li class="check">
          <input type="checkbox" id="neverShowAgain" name="neverShowAgain" v-model="neverShowAgain">
          <label for="neverShowAgain">{{ $t('次回以降表示しない') }}</label><br>
        </li>
        <li>
          <div class='button-wrapper'>
            <a class='button confirmBtn' @click='complete' data-ga-click-event="参考線ガイド確認">OK</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import PopupBase from './PopupBase.vue';

export default {
  name: 'ConfirmPopup',
  extends: PopupBase,
  data () {
    return {
      neverShowAgain: false
    };
  },
  methods: {
    complete () {
      this.$emit("complete", this.neverShowAgain);
    }
  }
};

</script>

<style lang="scss" scoped>

ul.text {
  li {
    margin-bottom: 4px;
    p {
      text-align: left;
    }

    &.item {
      list-style: disc;
    }
  }
  .check {
    margin-top: 1rem;
    display: flex;

    input {
      vertical-align: middle;
      margin-right: 3px;
    }
    label {
      vertical-align: middle;
      transform: rotateY(-1px);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/GuidelinePopup.vue